import { memo } from "react";
import Page from "components/page/Page";
import { Helmet } from "react-helmet";
import Card from "components/card/Card";
import { PageCollapseWidth } from "../../constants";
import GoogleAd from "components/googleAd/GoogleAd";
import { Link } from "react-router-dom";

const TermsAndConditionsPage = () => {
  return (
    <>
      <Helmet>
        <title>Terms and Conditions | ToolWeaver</title>
        <meta
          name="description"
          content="View the ToolWeaver terms and conditions for using our online tools and services."
        />
        <link
          rel="canonical"
          href="https://toolweaver.com/termsandconditions"
        />
      </Helmet>
      <Page>
        <GoogleAd hideOnWidth={PageCollapseWidth} />
        <Card collapseOnWidth={PageCollapseWidth} title="Terms and Conditions">
          <span className="d-block mb-4">
            Welcome to ToolWeaver! By accessing or using our website, you agree
            to comply with and be bound by the following terms and conditions.
            Please read them carefully. If you do not agree with any part of
            these terms, you must not use our website.
          </span>
          <ol>
            <li>
              Acceptance of Terms
              <span className="mt-3 mb-3 d-block">
                By accessing ToolWeaver, you acknowledge that you have read,
                understood, and agree to be bound by these terms and conditions.
                We reserve the right to modify these terms at any time, and such
                modifications shall be effective immediately upon posting on the
                website. Your continued use of the site constitutes your
                acceptance of the modified terms.
              </span>
            </li>
            <li>
              Use of ToolWeaver
              <span className="mt-3 mb-3 d-block">
                ToolWeaver provides a variety of online tools for web users free
                of charge. You agree to use these tools responsibly and for
                lawful purposes only. You must not use the site in any way that
                may damage, disable, overburden, or impair the site or interfere
                with any other party's use and enjoyment of the site.
              </span>
            </li>
            <li>
              Privacy Policy
              <span className="mt-3 mb-3 d-block">
                ToolWeaver does not collect any personal information from its
                users. However, we use Google Ads and Google Analytics, which
                may create tracking cookies for advertising and analytical
                purposes. By using our site, you consent to the use of cookies
                in accordance with our Privacy Policy. You can manage your
                cookie preferences through your browser settings.
              </span>
            </li>
            <li>
              Google Ads and Analytics
              <span className="mt-3 mb-3 d-block">
                Our website uses Google Ads to display advertisements and Google
                Analytics to analyze site traffic. These services may collect
                information about your use of the site, including your IP
                address, through cookies. This information is used to provide
                targeted advertisements and to improve our services. For more
                details, please refer to Google's Privacy Policy.
              </span>
            </li>
            <li>
              Intellectual Property
              <span className="mt-3 mb-3 d-block">
                All content, trademarks, and data on ToolWeaver, including but
                not limited to text, graphics, logos, and software, are the
                property of ToolWeaver or its content suppliers and are
                protected by applicable intellectual property laws. You may not
                reproduce, distribute, or create derivative works from any
                content on the site without express written permission from
                ToolWeaver.
              </span>
            </li>
            <li>
              Limitation of Liability
              <span className="mt-3 mb-3 d-block">
                ToolWeaver provides its tools and services "as is" and without
                any warranty or condition, express, implied, or statutory. We do
                not guarantee that the site will be uninterrupted, error-free,
                or free of viruses or other harmful components. ToolWeaver will
                not be liable for any damages of any kind arising from the use
                of this site, including but not limited to direct, indirect,
                incidental, punitive, and consequential damages.
              </span>
            </li>
            <li>
              Third-Party Links
              <span className="mt-3 mb-3 d-block">
                ToolWeaver may contain links to third-party websites. These
                links are provided for your convenience only, and ToolWeaver
                does not endorse or assume any responsibility for the content or
                practices of these third-party sites. Accessing these sites is
                at your own risk.
              </span>
            </li>
            <li>
              Governing Law
              <span className="mt-3 mb-3 d-block">
                These terms and conditions are governed by and construed in
                accordance with the laws of Western Australia. Any disputes
                arising from or related to the use of ToolWeaver shall be
                subject to the exclusive jurisdiction of the courts in Western
                Australia.
              </span>
            </li>
            <li>
              Contact Information
              <span className="mt-3 mb-3 d-block">
                If you have any questions or concerns about these terms and
                conditions, please <Link to="/contact">contact us</Link>.
              </span>
            </li>
          </ol>
          <span className="d-block mt-4">
            By using ToolWeaver, you agree to these terms and conditions. Thank
            you for visiting our site!
          </span>
        </Card>
      </Page>
    </>
  );
};

export default memo(TermsAndConditionsPage);
